webpackJsonp([88746230898986],{

/***/ 42:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @copyright 2015, Andrey Popp <8mayday@gmail.com>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Icon = function (_React$Component) {
	  _inherits(Icon, _React$Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.Component,
	          name = _props.name,
	          size = _props.size,
	          rotate = _props.rotate,
	          flip = _props.flip,
	          spin = _props.spin,
	          fixedWidth = _props.fixedWidth,
	          stack = _props.stack,
	          inverse = _props.inverse,
	          pulse = _props.pulse,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['Component', 'name', 'size', 'rotate', 'flip', 'spin', 'fixedWidth', 'stack', 'inverse', 'pulse', 'className']);
	
	      var classNames = 'fa fa-' + name;
	      if (size) {
	        classNames = classNames + ' fa-' + size;
	      }
	      if (rotate) {
	        classNames = classNames + ' fa-rotate-' + rotate;
	      }
	      if (flip) {
	        classNames = classNames + ' fa-flip-' + flip;
	      }
	      if (fixedWidth) {
	        classNames = classNames + ' fa-fw';
	      }
	      if (spin) {
	        classNames = classNames + ' fa-spin';
	      }
	      if (pulse) {
	        classNames = classNames + ' fa-pulse';
	      }
	
	      if (stack) {
	        classNames = classNames + ' fa-stack-' + stack;
	      }
	      if (inverse) {
	        classNames = classNames + ' fa-inverse';
	      }
	
	      if (className) {
	        classNames = classNames + ' ' + className;
	      }
	      return React.createElement(Component, _extends({}, props, { className: classNames }));
	    }
	  }]);
	
	  return Icon;
	}(React.Component);
	
	Icon.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  className: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['lg', '2x', '3x', '4x', '5x']),
	  rotate: _propTypes2.default.oneOf(['45', '90', '135', '180', '225', '270', '315']),
	  flip: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  fixedWidth: _propTypes2.default.bool,
	  spin: _propTypes2.default.bool,
	  pulse: _propTypes2.default.bool,
	  stack: _propTypes2.default.oneOf(['1x', '2x']),
	  inverse: _propTypes2.default.bool,
	  Component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Icon.defaultProps = {
	  Component: 'span'
	};
	exports.default = Icon;


/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @copyright 2015, Andrey Popp <8mayday@gmail.com>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var IconStack = function (_React$Component) {
	  _inherits(IconStack, _React$Component);
	
	  function IconStack() {
	    _classCallCheck(this, IconStack);
	
	    return _possibleConstructorReturn(this, (IconStack.__proto__ || Object.getPrototypeOf(IconStack)).apply(this, arguments));
	  }
	
	  _createClass(IconStack, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          size = _props.size,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['className', 'size', 'children']);
	
	      var classNames = ['fa-stack'];
	
	      if (size) {
	        classNames.push('fa-' + size);
	      }
	
	      if (className) {
	        classNames.push(className);
	      }
	
	      var iconStackClassName = classNames.join(' ');
	
	      return React.createElement(
	        'span',
	        _extends({}, props, { className: iconStackClassName }),
	        children
	      );
	    }
	  }]);
	
	  return IconStack;
	}(React.Component);
	
	IconStack.propTypes = {
	  className: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['lg', '2x', '3x', '4x', '5x']),
	  children: _propTypes2.default.node.isRequired
	};
	exports.default = IconStack;


/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconStack = exports.Icon = exports.default = undefined;
	
	__webpack_require__(42);
	
	var _Icon = __webpack_require__(46);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _IconStack = __webpack_require__(47);
	
	var _IconStack2 = _interopRequireDefault(_IconStack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Icon2.default;
	exports.Icon = _Icon2.default;
	exports.IconStack = _IconStack2.default; /**
	                                          * @copyright 2015, Andrey Popp <8mayday@gmail.com>
	                                          * 
	                                          */


/***/ }),

/***/ 758:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/divider3.8db868f2.jpg";

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(40);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _sortBy = __webpack_require__(44);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _reactHelmet = __webpack_require__(49);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactFa = __webpack_require__(48);
	
	var _reactObfuscate = __webpack_require__(109);
	
	var _reactObfuscate2 = _interopRequireDefault(_reactObfuscate);
	
	var _divider = __webpack_require__(758);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* https://www.npmjs.com/package/react-obfuscate */
	
	/* import { Follow } from 'react-twitter-widgets' */
	
	var HeaderComplete = function (_React$Component) {
		_inherits(HeaderComplete, _React$Component);
	
		function HeaderComplete() {
			_classCallCheck(this, HeaderComplete);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		HeaderComplete.prototype.render = function render() {
			// console.log("props", this.props)
			// const pageLinks = []
			// const site = get(this, 'props.data.site.siteMetadata')
			return _react2.default.createElement(
				'div',
				{ id: 'headerwrap', name: 'home', style: { backgroundImage: 'url(' + _divider2.default + ')' } },
				_react2.default.createElement(
					'header',
					{ className: 'clearfix' },
					_react2.default.createElement(
						'h1',
						null,
						_react2.default.createElement('span', { className: 'icon icon-w' })
					),
					_react2.default.createElement(
						'p',
						null,
						'Christian Wolter'
					)
				)
			);
		};
	
		return HeaderComplete;
	}(_react2.default.Component);
	
	var Footer = function (_React$Component2) {
		_inherits(Footer, _React$Component2);
	
		function Footer() {
			_classCallCheck(this, Footer);
	
			var _this2 = _possibleConstructorReturn(this, _React$Component2.call(this));
	
			_this2.state = {
				intervalId: 0
			};
			return _this2;
		}
	
		Footer.prototype.scrollStep = function scrollStep() {
			if (window.pageYOffset === 0) {
				clearInterval(this.state.intervalId);
			}
			window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
		};
	
		Footer.prototype.scrollToTop = function scrollToTop() {
			var intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
			this.setState({ intervalId: intervalId });
		};
	
		Footer.prototype.render = function render() {
			var _this3 = this;
	
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					{ id: 'footerwrap' },
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							'h4',
							null,
							_react2.default.createElement(
								'small',
								null,
								'created by Christian Wolter - copyright 2019 - ',
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/imprint', onClick: function onClick() {
											_this3.scrollToTop();
										} },
									'imprint | disclaimer'
								),
								' -  ',
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/privacy', onClick: function onClick() {
											_this3.scrollToTop();
										} },
									'privacy'
								)
							)
						)
					)
				)
			);
		};
	
		return Footer;
	}(_react2.default.Component);
	
	var ScrollButton = function (_React$Component3) {
		_inherits(ScrollButton, _React$Component3);
	
		function ScrollButton() {
			_classCallCheck(this, ScrollButton);
	
			var _this4 = _possibleConstructorReturn(this, _React$Component3.call(this));
	
			_this4.state = {
				intervalId: 0
			};
			return _this4;
		}
	
		ScrollButton.prototype.scrollStep = function scrollStep() {
			if (window.pageYOffset === 0) {
				clearInterval(this.state.intervalId);
			}
			window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
		};
	
		ScrollButton.prototype.scrollToTop = function scrollToTop() {
			var intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
			this.setState({ intervalId: intervalId });
		};
	
		ScrollButton.prototype.render = function render() {
			var _this5 = this;
	
			return _react2.default.createElement(
				'button',
				{ title: 'Back to top', className: 'scroll',
					onClick: function onClick() {
						_this5.scrollToTop();
					} },
				_react2.default.createElement('span', { className: 'arrow-up glyphicon glyphicon-chevron-up' })
			);
		};
	
		return ScrollButton;
	}(_react2.default.Component);
	
	var spacer = {
		paddingLeft: '30px'
	};
	
	var iconStyle = {
		opacity: '0.5',
		width: '30px'
	};
	
	var Projects = function (_React$Component4) {
		_inherits(Projects, _React$Component4);
	
		function Projects() {
			_classCallCheck(this, Projects);
	
			return _possibleConstructorReturn(this, _React$Component4.apply(this, arguments));
		}
	
		Projects.prototype.render = function render() {
			var pathPrefix =  false ? '' : ("");
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(HeaderComplete, null),
				_react2.default.createElement(
					'div',
					{ className: 'container', id: 'disclaimer', name: 'disclaimer' },
					_react2.default.createElement('br', null),
					_react2.default.createElement('br', null),
					_react2.default.createElement(
						'div',
						{ className: 'row' },
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							'h1',
							{ className: 'centered' },
							'contact'
						),
						_react2.default.createElement('hr', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							'div',
							{ className: 'col-md-4' },
							_react2.default.createElement(
								'h3',
								null,
								'contact'
							),
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(_reactFa.Icon, { name: 'user', style: iconStyle }),
								'Christian Wolter',
								_react2.default.createElement('br', null),
								_react2.default.createElement(_reactFa.Icon, { name: 'map-marker', style: iconStyle }),
								'Poppenreutherstr. 49a',
								_react2.default.createElement('br', null),
								_react2.default.createElement(
									'span',
									{ style: spacer },
									'90419 N\xFCrnberg'
								),
								_react2.default.createElement('br', null),
								_react2.default.createElement(_reactFa.Icon, { name: 'envelope', style: iconStyle }),
								_react2.default.createElement(_reactObfuscate2.default, {
									email: 'contact@christian-wolter.com',
									headers: { subject: 'Contact via webpage' } })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-md-4' },
							_react2.default.createElement(
								'h3',
								null,
								'LinkedIn'
							),
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(_reactFa.Icon, { name: 'linkedin', style: iconStyle }),
								' ',
								_react2.default.createElement(
									'a',
									{ href: 'https://www.linkedin.com/in/christian-wolter/', target: '_blank' },
									'LinkedIn.com'
								)
							),
							_react2.default.createElement(
								'h3',
								null,
								'xing'
							),
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(_reactFa.Icon, { name: 'xing', style: iconStyle }),
								' ',
								_react2.default.createElement(
									'a',
									{ href: 'https://www.xing.com/profile/Christian_Wolter10', target: '_blank' },
									'xing.com'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-md-4' },
							_react2.default.createElement(
								'h3',
								null,
								'blog:'
							),
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(_reactFa.Icon, { name: 'rss', style: iconStyle }),
								_react2.default.createElement(
									'a',
									{ href: 'http://blog.christian-wolter.com' },
									'blog.christian-wolter.com'
								)
							)
						)
					)
				),
				_react2.default.createElement(ScrollButton, { scrollStepInPx: '50', delayInMs: '16.66' }),
				_react2.default.createElement(Footer, null)
			);
		};
	
		return Projects;
	}(_react2.default.Component);
	
	exports.default = Projects;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-index-jsx-2f9053c69ff027156f63.js